import * as Yup from 'yup';

import {AccountApplication} from '@application/Account';
import {handleUpdateError} from '@views/Account/Account.controller';

import {TEXT} from './ResetPassword.definition';

const submitForm =
  ({toast: {showSuccess, showError}, formatMessage, onSubmit}) =>
  async ({password = ''}, {setSubmitting}) => {
    try {
      await AccountApplication.resetPassword(password);
      showSuccess({message: formatMessage(TEXT.NOTIFICATION_SUCCESS)});
      onSubmit();
    } catch {
      handleUpdateError({showError, formatMessage});
    } finally {
      setSubmitting(false);
    }
  };

const validateSchema = ({intl: {formatMessage}}) =>
  Yup.object().shape({
    password: Yup.string('Field incorrect type').required(formatMessage(TEXT.INPUT_ERROR_EMPTY)),
    repeatPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], formatMessage(TEXT.INPUT_ERROR_NOT_MATCH))
      .required(formatMessage(TEXT.INPUT_ERROR_EMPTY)),
  });

export {submitForm, validateSchema};
